import { CollezioneItemType } from '@utils/types'
import { useTrans } from '../../../hooks'
import { ScrollRef, WContainer } from '../../atoms'
import { CardCollezioneList } from '../../molecules'
import styles from './Decorations.module.sass'

interface Props {
  refId?: string
  collezione: any
  className?: string
}

const Decorations = (props: Props) => {
  const { refId = undefined, collezione = undefined, className = '' } = props

  const t = useTrans()

  return collezione?.decori?.length ? (
    <div className={`${styles.root} ${className}`}>
      {!!refId && <ScrollRef id={refId} offset={false} className={styles.ref} />}
      <WContainer>
        <div className={`${styles.layout}`}>
          <h2 className={styles.title}>{t('Decori')}</h2>
          <div className={styles.content}>
            <CardCollezioneList items={collezione.decori} variant="decori" />
          </div>
        </div>
      </WContainer>
    </div>
  ) : (
    <></>
  )
}

export default Decorations
